import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import SearchFactory from '../SearchFactory/SearchFactory';

import SearchUserByEC from '../SearchUserByEC/SearchUserEC';

const AddPayrollPic = ({ handleClose, show, onAdd, factories, token}) => {
    const [payrollPicName, setPayrollPicName] = useState('');
    const [payrollPicBadgeId, setPayrollPicBadgeId] = useState('');
    const [payrollPicUsername, setPayrollPicUsername] = useState('');
    const [payrollPicEmail, setPayrollPicEmail] = useState('');
    const [groupFactories, setGroupFactories] = useState([]);
    const [createdBy, setCreatedBy] = useState('');  

    useEffect(() => {
        // spliy email address from @ onwards to get username
        const email = localStorage.getItem('email');
        const username = email.split('@')[0];
        setCreatedBy(username);
    }, []);
    

    const onSubmit = (e) => {
        e.preventDefault();

        if (!payrollPicUsername) {
            alert('Please select a payrollPic');
        } else if (groupFactories.length === 0) {
            alert('Please select at least a user');
        } else {
            const factoryId = groupFactories.map((item) => item.id).toString();

            onAdd({
                factoryId,
                payrollPicName,
                payrollPicBadgeId,
                payrollPicUsername,
                payrollPicEmail,
                createdBy,
            });
        }
    };

     // get user details
     const getPayrollPicDetails = (payrollPicProp) => {
        if (payrollPicProp) {
            setPayrollPicName(payrollPicProp.label)
            setPayrollPicBadgeId(payrollPicProp.value)
            setPayrollPicEmail(payrollPicProp.email)
            setPayrollPicUsername(payrollPicProp.username)
            console.log(payrollPicProp)
        }
        else {
            setPayrollPicName('');
            setPayrollPicBadgeId('');
            setPayrollPicEmail('');
            setPayrollPicUsername('');

        }
    }


    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title style={{ marginBottom: '0px' }}>
                    Add Payroll PIC
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={onSubmit}>
                    <Form.Group className='mb-3'>
                        <Form.Label>Payroll PIC</Form.Label>
                        <SearchUserByEC getSuperiorDetails={getPayrollPicDetails} token={token}/>
                    </Form.Group>
                      <Form.Group className='mb-3'>
                        <Form.Label>Factories</Form.Label>
                        <SearchFactory setFactories={setGroupFactories} />
                    </Form.Group>
                    <Button as='input' type='submit' value='Submit' />
                    <Button variant='outline-secondary' onClick={handleClose}>
                        Close
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AddPayrollPic;
